import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getVipConfigList } from '@/api/vip'

export const useVipStore = defineStore('vip', () => {
  // VIP等级列表
  const vipList = ref([])
  const loading = ref(false)

  // 获取VIP配置列表
  const getVipList = async () => {
    if (vipList.value.length > 0) {
      return vipList.value
    }
    
    loading.value = true
    try {
      const res = await getVipConfigList({
        page: 1,
        pageSize: 100 // 获取所有VIP等级
      })
      
      if (res.code === 0 && res.data?.list) {
        // 转换为统一的选项格式，按grade排序
        vipList.value = res.data.list
          .sort((a, b) => a.grade - b.grade)
          .map(item => ({
            label: `VIP${item.grade}`,
            value: item.grade,
            ...item
          }))
      }
      return vipList.value
    } catch (error) {
      console.error('获取VIP列表失败:', error)
      return []
    } finally {
      loading.value = false
    }
  }

  // 刷新VIP列表
  const refreshVipList = async () => {
    vipList.value = []
    return await getVipList()
  }

  // 初始化VIP数据
  const initVipData = async () => {
    if (vipList.value.length === 0) {
      await getVipList()
    }
  }

  // 获取指定范围的VIP选项
  const getVipOptions = (min = 0, max = 999) => {
    return vipList.value.filter(item => 
      item.value >= min && item.value <= max
    )
  }

  return {
    vipList,
    loading,
    getVipList,
    refreshVipList,
    initVipData,
    getVipOptions
  }
}) 